import { render, staticRenderFns } from "./VendorCreate.vue?vue&type=template&id=22f5db43"
import script from "./VendorCreate.vue?vue&type=script&lang=js"
export * from "./VendorCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports